<template>
    <crud-facecade
     ref="slist"
        :url="url"
        :columns="columnList"
        :tableHeight="tableHeight"
        :buttons="[]"
        v-wechat-title="title"
        :addButton="{ enabled: false, permission: 'default' }"
        :deleteButton="{ enabled: false, permission: 'default' }"
        :updateButton="{ enabled: false, permission: 'default' }"
    >
        <slot slot="filter">
            <el-col :md="8" :lg="6" :xl="4" class="align-left">
                <item-input type="string" v-model="orderid" placeholder="出库单号"></item-input>
            </el-col>
        </slot>
    </crud-facecade>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `OutboundOrder`,
    data() {
        return {
            title: `出库单查询`,
            orderid: ``,
            url: {
                baseURL: `/api/Nursing/PackageOutboundOrder`,
                get: paras => {
                    return new Promise(resolve => {
                        this.ReloadData().then(data => {
                            resolve(data)
                        })
                    })
                }
            }
        }
    },
    created() {
    },
    computed: {
        ...mapGetters([`sys_enums`, `is_enabled`, `menu_icons`, `img_icons`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `ID`,
                    isListable: false,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `order_id`,
                    label: `出库单号`,
                    isListable: true,
                    sortable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `internal_code`,
                    label: `器械包条码号`,
                    isListable: true,
                    sortable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `package_name`,
                    label: `器械包名称`,
                    isListable: true,
                    sortable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `datetime`,
                    prop: `outbound_time`,
                    label: `出库时间`,
                    width: `140`,
                    isListable: true,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `status`,
                    label: `状态`,
                    width: `100`,
                    isListable: true,
                    sortable: true
                }
            ]
        }
    },
    methods: {
        ReloadData() {
            return new Promise((resolve, reject) => {
                let that = this
                if (that.orderid) {
                    let req = this.myaxios.get(`/api/Nursing/PackageOutboundOrder/GetByOrderId?OrderId=${that.orderid}`)
                    req.then(data => {
                        let r = data
                        resolve(r)
                    }).catch(e => {
                        console.log(e)
                    })
                }
            })
        }
    },
    watch: {
        orderid: function() {
            this.$refs[`slist`].ReloadListData()
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Instrument/OutboundOrder.vue